import Loader from './Loader';

module.exports = Loader;



// WEBPACK FOOTER //
// ./src/index.js